import * as React from 'react';
import UIList from 'UIComponents/list/UIList';
import WorkflowName from 'automation-ui-references/customer-data/WorkflowName';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WebhookModalUsageBody = ({
  crmUsages,
  webhookDefinition
}) => {
  if (crmUsages.length === 0) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "automation-ui-enrollment.webhookWizard.deleteModal.description",
      options: {
        webhookName: webhookDefinition.label
      }
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "automation-ui-enrollment.webhookWizard.deleteModal.workflowsInUse.cantBeDeleted",
      options: {
        webhookName: webhookDefinition.label
      }
    }), /*#__PURE__*/_jsx(UIList, {
      styled: true,
      className: "m-top-3 p-left-7",
      children: crmUsages.map(usage => /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(WorkflowName, {
          flowSourceType: "PLATFORM",
          id: usage.parentName,
          href: usage.parentUsageUri
        })
      }, usage.parentName))
    }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "automation-ui-enrollment.webhookWizard.deleteModal.workflowsInUse.pleaseRemove",
      options: {
        webhookName: webhookDefinition.label
      }
    })]
  });
};
export default WebhookModalUsageBody;